import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button as ZButton, Switch as ZSwitch } from "@zebra-fed/zds-react-desktop";
import styled from "styled-components";
import { DataContext } from "../data/DataContext";
import { AuthContext } from '../authentication/Auth';
import firebaseUtil from "../data/FirebaseUtil";
import {
    FormControl,
    FormControlLabel,
    Switch,
    RadioGroup,
    Radio,
    Button
} from '@material-ui/core';
import {
    SnackbarContent,
    PageTitle
} from "../styled-components/shared";
import Snackbar from "@material-ui/core/Snackbar";
import { useTranslation } from "react-i18next";
import TextField from "@material-ui/core/TextField";
import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from "@material-ui/core/CircularProgress";
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import BottomNavLinks from '../components/BottomNavLinks';
import app from '../authentication/firebaseStart';
import { DLR_MACHINE_LEARNING } from './../data/constants';
import LinearProgressWithLabel from '../components/ProgressBar';

const Section = styled.div`
    margin-top: 0px;
`;

const SVGContainer = styled.div`
    display: flex;
    align-items: center;
    cursor:pointer;
    margin-left: 10px;
    svg{
        font-size: 22px;
        color:#545963;
        &:hover{
        color:#545963;
        }
    }
`;

const TTBody = styled.p`
    color: #fff;
    font-weight: 400;
    font-size: 14px;
    text-align: left;
    font-family: "IBM Plex Sans", sans-serif;
    font-style: normal;
    line-height: 20px;
`;

const PageTitleDiv = styled.div`
    display: flex;
    height: 64px;
    align-items: center;
    flex-shrink: 0;
`

const PageHeader = styled.p`
    color: var(--Light-Mode-Text-Default, var(--text-default, #1D1E23));
    /* Standard/Headline/Medium */
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 28px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px; /* 114.286% */
`

const PageLabel = styled.p`
    color: var(--Light-Mode-Text-Default, var(--text-default, #1D1E23));
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    display: flex;
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px;
`

const DescriptionBlock = styled.div`
    display: flex;
    padding: 0px 36px;
    justify-content: center;
    align-items: flex-start;
    gap: 8px;
`

const DescriptionText = styled.p`
    color: var(--Light-Mode-Text-Subtle, var(--text-subtle, #545963));

    /* Standard/Body/Medium */
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
    width: 665px;
`

const SwitchCustomColor = withStyles({
    switchBase: {
        color: "white",
        '&$checked': {
            color: "white",
        },
        '&$checked + $track': {
            backgroundColor: "#0073e6",
            opacity: 1,
        },
    },
    checked: {},
    track: {},
})(Switch);

const ButtonContainerOld = styled.div`
    display: flex;
`;

const ButtonContainer = styled.div`
    display: flex;
    width: 768px;
    padding: 16px 0px;
    justify-content: space-between;
    align-items: flex-start;
    flex-shrink: 0;
    font-family: "IBM Plex Sans", sans-serif;
`;

const NoMarginP = styled.p`
    margin : 0px;
`;

const CheckboxComp = styled.div`
    display: flex;
    align-items: center;
    margin-left: -8px;
    font-size: 20px;
`;

const CheckboxCompSub = styled.div`
    display: flex;
    align-items: center;
    @media screen and (max-width: 750px){
        margin-left: 10px;
    }
`;

const PSub = styled.p`
    display: flex;
    align-items: center;
    margin: 10px;
    margin-left: 48px;
    width: 60%;
    // border: 2px solid red;
    display: flex;
    justify-content: space-between;
    @media screen and (max-width: 700px){
        margin-left: 0px;
        width: 100%;
    }
`;

const PSubHeading = styled.p`
    display: flex;
    align-items: center;
    margin: 10px 0px;
    width: 13%;
    display: flex;
    justify-content: space-between;
    @media screen and (max-width: 700px){
        margin-left: 0px;
        width: 100%;
    }
`;


const Pprocessing = styled.p`
    opacity: 1;
    text-align: center;
    position: relative;
    font-weight: 500;
    font-size: 20px;
    @media screen and (max-width: 700px){
        margin-left: 0px;
        width: 100%;
    }
`;

const PageWrapper = styled.div`
    background: white;
    box-shadow: 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%), 0 1px 3px 0 rgb(0 0 0 / 20%);
    padding: 20px;
    font-family: proxima-nova,Proxima Nova,Arial,Helvetica,sans-serif;
`;

const RuleTitle = styled.div`
    display: flex;
    font-size: 19px;
    font-weight: 600;
    font-style: normal;
    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px;
    margin-bottom: 10px;
`;

const StyledTextFieldOld = styled(TextField)`
  width: 150px;
  display: flex;
`;

const StyledTextField = styled(TextField)`
  display: flex;
  width: 100%;

  input{
  padding: 12px !important;

      &:focus{
        border-color:#2684FF !important;
    }
  }

  & .MuiOutlinedInput-root {
      &.Mui-focused fieldset {
        border-color: #2684FF !important;
      }
    }
`;

const StyledLink = styled.p`
    color: var(--Light-Mode-Text-Accent, var(--color-blue-60, #0073E6));

    /* Standard/Label Medium */
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    text-decoration: none;
    cursor: pointer;
`

const MainLayout = styled.div`
    display: flex;
    padding: 24px 24px 16px 24px;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 16px;
    background: var(--Main-Neutral-White, #FFF);
`

const ErrorMsg = styled.p`
    margin: 0;
    padding-left: 10px;
    font-size: 0.75rem;
    margin-top: 3 px;
    text-align: left;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    line-height: 1.66;
    letter-spacing: 0.03333em;
    color: red;
`;

function WorkFlow() {
    const firestore = app.firestore();
    const history= useHistory();
    const context = useContext(AuthContext);
    const companyID = context.currentUser.claims.companyID;
    let { globalAppSettings, setGlobalAppSettings } = useContext(DataContext);
    const {t} = useTranslation();
    let [localRulesArr] = useState([
        {
            mobile: {
                toBeFoundRules: {
                    rule1: {
                        definition: {
                            checkOutState: true,
                            isCharging: false,
                            lowBattery: true,
                        },
                        title: t('workFlow.toBeFoundRules.rule1'),
                        executionMode: 0,
                        validation: {
                            exclusiveOf: [
                                'rule5'
                            ]
                        }
                    },
                    rule2: {
                        definition: {
                            checkOutState: true,
                            isCharging: false,
                            lowBattery: true,
                            isIdle: true
                        },
                        title: t('workFlow.toBeFoundRules.rule2'),
                        executionMode: 0,
                        validation: {
                            exclusiveOf: [
                                'rule5', 'rule6'
                            ]
                        }
                    },
                    rule3: {
                        definition: {
                            checkOutState: true,
                            checkedOutAt: true
                        },
                        title: t('workFlow.toBeFoundRules.rule3'),
                        executionMode: 1,
                        validation: {
                            exclusiveOf: []
                        }
                    },
                    rule4: {
                        definition: {
                            checkOutState: false,
                            isCharging: false,
                            lowBattery: true,
                        },
                        title: t('workFlow.toBeFoundRules.rule4'),
                        executionMode: 0,
                        validation: {
                            exclusiveOf: []
                        }
                    },
                    rule5: {
                        definition: {
                            isCharging: false,
                            lowBattery: true,
                        },
                        title: t('workFlow.toBeFoundRules.rule5'),
                        executionMode: 0,
                        validation: {
                            exclusiveOf: [
                                'rule1'
                            ]
                        }
                    },
                    rule6: {
                        definition: {
                            isCharging: false,
                            lowBattery: true,
                            isIdle: true
                        },
                        title: t('workFlow.toBeFoundRules.rule6'),
                        executionMode: 0,
                        validation: {
                            exclusiveOf: [
                                'rule2'
                            ]
                        }
                    },
                    rule7: {
                        definition: {
                            isCharging: false,
                            isIdle: true
                        },
                        title: t('workFlow.toBeFoundRules.rule7'),
                        executionMode: 0,
                        validation: {
                            exclusiveOf: [
                                'rule2', 'rule6'
                            ]
                        }
                    },
                    rule8: {
                        definition: {
                            connectionState: 2
                        },
                        title: 'Disconnected',
                        executionMode: 0,
                        validation: {
                            exclusiveOf: []
                        }
                    }
                }
            }
        },
    ])
    const [toBeFoundRules, setToBeFoundRules] = useState({})
    const [savedRules, setSavedRules] = useState({
        enableToBeFoundAutomation: false,
        lowBatteryThreshold: 'Device default',
        idleThreshold: 15
    })
    const [otherRules, setOtherRules] = useState({
        enableToBeFoundAutomation: false,
        lowBatteryThreshold: 'Device default',
        idleThreshold: 15
    })
    console.log(otherRules, 'otherRulesotherRules')
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [valuesChanged, setValuesChanged] = useState(false)
    const serverResponse = useRef("");
    const [otherRulesError, setOtherRulesError] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [isLoading2, setIsLoading2] = useState(true)
    const [isRuleBased, setIsRuleBased] = useState(true);
    const [isMlUpdateInProgress, setIsMlUpdateInProgress] = useState(false);
    const [lastMlStatus, setLastMlStatus] = useState(DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.DISABLE);
    const [isPredictionAvailable, setIsPredictionAvailable] = useState(false);
    const [processingTimer, setProcessingTimer] = useState("");
    const [progressBarValue, setProgressBarValue] = useState(0);
    const [retryStatus, setRetryStatus] = useState(-1);
    const [isScreenBlock, setScreenBlock] = useState(false);
    // DLR flagf
    const { dlrFeatureFlag, setMlPredictionStatus } = useContext(DataContext);

    /**
     * This Function convert the time from miliseconds to hour and minute
     * @param {Number} time : Time in miliseconds
     * @returns {String} : return the time in string format e.g 2 Hours and 5 Minutes
     */
    const convertToHourAndMinute = (time) => {
        let timeString = "";
        let hour = parseInt(time/(1000 * 60 * 60));
        let minute = Math.round(time%(1000 * 60 * 60)/(1000 * 60));
        timeString = hour > 0 ? hour == 1 ? `${hour} hr` : `${hour} hrs` : "";
        timeString = timeString.length > 0 ? `${timeString} and ` : "";
        timeString = minute > 1 ? `${timeString}${minute} Mins` : `${timeString}${minute} Min`;
        return timeString;
    }


    useEffect(() => {
        if (Object.keys(globalAppSettings).length > 0) {
            setDbToLocal();
            setIsLoading2(false);
        } else {
            setTimeout(() => {
                setIsLoading2(false)
            }, 1000)
        }
    }, [globalAppSettings])

    const onClickResetBtn = () => {
        setOtherRules({
            enableToBeFoundAutomation: false,
            lowBatteryThreshold: 'Device default',
            idleThreshold: 15
        });
        setIsRuleBased(true);
    }

    const detectMlPredictionStatusChanges = async () => {
        firestore
            .collection('tenants')
            .doc(companyID)
            .collection('Configuration')
            .doc('AppSettings')
            .collection("DLRSettings")
            .doc("DLRConfig")
            .onSnapshot((querySnapshot) => {
                console.log(querySnapshot.data())
                if(querySnapshot.data()){
                    setIsPredictionAvailable(true);
                    // const status = 3
                    const status = querySnapshot.data().MLPredictionStatus;
                    if(status === DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.DISABLE || status === DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.DISABLE_IN_PROGRESS){
                        setIsRuleBased(true);
                        setLastMlStatus(DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.DISABLE);
                        setMlPredictionStatus(false);
                    }
                    else if(status === DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.ENABLE || status === DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.ENABLE_IN_PROGRESS){
                        setIsRuleBased(false);
                        setLastMlStatus(DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.ENABLE);
                        setMlPredictionStatus(true);
                    }

                    if(status === DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.ENABLE_IN_PROGRESS || 
                        status === DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.DISABLE_IN_PROGRESS){
                        setIsMlUpdateInProgress(true);}
                    else{
                        setProcessingTimer("0 Mins");
                        setProgressBarValue(100);
                        setTimeout(()=> {
                            setIsMlUpdateInProgress(false);
                        }, 1000)
                    }
                }
                else{
                    setIsPredictionAvailable(false);
                    setIsRuleBased(true);
                    setMlPredictionStatus(false);
                }
            })
    }

    const listenRemainingTimeForProcessing = async () => {
        firestore
            .collection('tenants')
            .doc(companyID)
            .collection('Configuration')
            .doc('AppSettings')
            .collection("DLRSettings")
            .doc("DLRProcessingInfo")
            .onSnapshot((querySnapshot) => {
                let remainingTime = querySnapshot.data();
                if(isMlUpdateInProgress){
                    setProcessingTimer("0 Mins");
                    setProgressBarValue(100);
                }
                else if(remainingTime?.remainingTime){
                    setProcessingTimer(convertToHourAndMinute(remainingTime.remainingTime));
                    if(remainingTime?.progressPercentage && remainingTime.progressPercentage >= 0 && remainingTime.progressPercentage <= 100)
                        setProgressBarValue(remainingTime.progressPercentage);
                    else
                        setProgressBarValue(0)
                }
                else{
                    setProcessingTimer("0 Mins");
                    setProgressBarValue(100);
                    setTimeout(()=> {
                        setProcessingTimer("");
                        setProgressBarValue(0);
                    }, 1000)
                }
            })
    }

    const listenBulkRetryConfigStatus = async () => {
        firestore
            .collection('tenants')
            .doc(companyID)
            .collection('Configuration')
            .doc('AppSettings')
            .collection("DLRSettings")
            .doc("DLRBulkRetryConfig")
            .onSnapshot((querySnapshot) => {
                let data = querySnapshot.data();
                if(data && typeof undefined != typeof data.retryStatus){
                    setRetryStatus(data.retryStatus);
                }
            })
    }

    useEffect(()=> {
        // checking ml prediction status only if dlr feature is enabled
        if(dlrFeatureFlag){
            detectMlPredictionStatusChanges();
            listenRemainingTimeForProcessing();
            listenBulkRetryConfigStatus();
        }
    },[]);

    useEffect(() => {
        if(isMlUpdateInProgress || retryStatus == DLR_MACHINE_LEARNING.BULK_RETRY_CONFIG_STATUS.RETRY_INPROGRESS)
            setScreenBlock(true);
        else    setScreenBlock(false);
    }, [isMlUpdateInProgress, retryStatus])

    useEffect(() => {
        if(!isEqualObjects(otherRules, savedRules) || !isMlStatusEqual()){
            setValuesChanged(true);
        }
        else{
            setValuesChanged(false);
        }
    }, [otherRules, isRuleBased, lastMlStatus]);

    const setDbToLocal = () => {
        let toBe = globalAppSettings.workFlowData
        console.log(toBe, 'tobe')
        setOtherRules(prevState => ({
            ...prevState,
            enableFoundAutomation: typeof toBe?.enableFoundAutomation == typeof undefined ? false : toBe?.enableFoundAutomation,
            enableIdleDetection: typeof toBe?.enableIdleDetection == typeof undefined ? false : toBe?.enableIdleDetection,
            enableToBeFoundAutomation: typeof toBe?.enableToBeFoundAutomation == typeof undefined ? false : toBe?.enableToBeFoundAutomation,
            idleThreshold: toBe?.idleThreshold ? toBe?.idleThreshold : 15,
            lowBatteryThreshold: (toBe?.lowBatteryThreshold || toBe?.lowBatteryThreshold === 0) ? toBe?.lowBatteryThreshold === 9999 ? "Device default" : toBe?.lowBatteryThreshold : "Device default",
            enableInServiceOnCheckout: typeof toBe?.enableInServiceOnCheckout == typeof undefined ? false : toBe?.enableInServiceOnCheckout,
            maxCheckoutTime: typeof toBe?.maxCheckoutTime == typeof undefined ? null : toBe?.maxCheckoutTime
        }))
        setSavedRules(prevState => ({
            ...prevState,
            enableFoundAutomation: typeof toBe?.enableFoundAutomation == typeof undefined ? false : toBe?.enableFoundAutomation,
            enableIdleDetection: typeof toBe?.enableIdleDetection == typeof undefined ? false : toBe?.enableIdleDetection,
            enableToBeFoundAutomation: typeof toBe?.enableToBeFoundAutomation == typeof undefined ? false : toBe?.enableToBeFoundAutomation,
            idleThreshold: toBe?.idleThreshold ? toBe?.idleThreshold : 15,
            lowBatteryThreshold: (toBe?.lowBatteryThreshold || toBe?.lowBatteryThreshold === 0) ? toBe?.lowBatteryThreshold === 9999 ? "Device default" : toBe?.lowBatteryThreshold : "Device default",
            enableInServiceOnCheckout: typeof toBe?.enableInServiceOnCheckout == typeof undefined ? false : toBe?.enableInServiceOnCheckout
        }))
        let toBeRules = {};
        toBeRules = toBe?.toBeFoundRules ? toBe?.toBeFoundRules : {};
        setToBeFoundRules(toBeRules)
        setIsLoading(false)
    }

    const onChangeOtherRules = (value, name) => {

        // if ( name === 'enableToBeFoundAutomation' || name === 'enableFoundAutomation') {
        //     value = value.target.checked;
        // }

        /* to change setvalues chaned to false if the previous value matches */
        if (name === 'enableIdleDetection') {
            if (value === otherRules.enableIdleDetection) {
            }
            else {
                setOtherRules(prevState => ({
                    idleThreshold: 15,
                    ...prevState,
                    [name]: value
                }))
            }
        }
        else {
            setOtherRulesError(prevState => ({
                ...prevState,
                [name]: ''
            }))
            if (name === 'enableToBeFoundAutomation' && value === false) {
                setToBeFoundRules({})
            }
            if (name === 'lowBatteryThreshold' || name === 'idleThreshold') {

                if (name === 'lowBatteryThreshold') {
                    value = value.replace(/[^0-9]/gi, '');
                    if (value > 100) {
                        setOtherRulesError(prevState => ({
                            ...prevState,
                            lowBatteryThreshold: 'lowBatteryMaxValue'
                        }))
                        return
                    }
                    if (value && value < 5) {
                        setOtherRulesError(prevState => ({
                            ...prevState,
                            lowBatteryThreshold: 'lowBatteryMinValue'
                        }))
                        value = parseInt(value)
                        // return
                    }
                    else if (value) {
                        value = parseInt(value)
                    }
                }

                if (name === 'idleThreshold') {
                    value = value.replace(/[^0-9]/gi, '');
                    if (value > 100000) {
                        setOtherRulesError(prevState => ({
                            ...prevState,
                            idleThreshold: 'idleThresholdMaxValue'
                        }))
                        return
                    }
                    if (value && value < 5) {
                        setOtherRulesError(prevState => ({
                            ...prevState,
                            idleThreshold: 'idleThresholdMinValue'
                        }))
                        value = parseInt(value)
                        // return
                    }
                    else if (value) {
                        value = parseInt(value)
                    }
                    // if ( value ) {
                    //     value = parseInt(value)
                    // }
                }
            }
            if(name === 'maxCheckoutTime'){
                value = value.replace(/[^0-9]/gi, '');
            }
            
            setOtherRules(prevState => ({
                ...prevState,
                [name]: value
            }))
        }

    }

    const isEqualObjects = (obj1, obj2) => {
        let status = true;
        for(let key in obj1){
            if(obj1[key] != obj2[key]){
                status = false;
            }
        }
        return status
    }

    const isMlStatusEqual = () => {
        if(!dlrFeatureFlag)     return true;
        else if((lastMlStatus === DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.ENABLE && !isRuleBased) || 
            (lastMlStatus === DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.DISABLE && isRuleBased)
        ){
            return true;
        }
        else if((lastMlStatus === DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.ENABLE && isRuleBased) || 
        (lastMlStatus === DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.DISABLE && !isRuleBased)
        ){
            return false;
        }
    }

    const onClickRulesSaveBtn = () => {
        if(dlrFeatureFlag){
            // if dlr features is enable then only we are updating ml prediction status
            if(isRuleBased && lastMlStatus === DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.ENABLE){
                changeMLPredictionStatus(DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.DISABLE_IN_PROGRESS);
            }
            else if(!isRuleBased && lastMlStatus === DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.DISABLE){
                changeMLPredictionStatus(DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.ENABLE_IN_PROGRESS);
            }
        }
        let pushData = otherRules;
        if (!otherRules.lowBatteryThreshold && otherRules.lowBatteryThreshold !== 0) {
            setOtherRulesError(prevState => ({
                ...prevState,
                lowBatteryThreshold: 'valueEmpty'
            }))
        }
        if (otherRules.enableIdleDetection && !otherRules.idleThreshold) {
            setOtherRulesError(prevState => ({
                ...prevState,
                idleThreshold: 'valueEmpty'
            }))
        }
        // else if (( otherRules.lowBatteryThreshold && otherRules.lowBatteryThreshold >= 5 ) &&
        else if (((otherRules.lowBatteryThreshold && otherRules.lowBatteryThreshold >= 5) || otherRules.lowBatteryThreshold === 'Device default') &&
            (otherRules.idleThreshold && otherRules.idleThreshold >= 5 && otherRules.idleThreshold <= 100000)) {
            pushData['toBeFoundRules'] = toBeFoundRules;
            pushData['lowBatteryThreshold'] = pushData.lowBatteryThreshold === "Device default" ? 9999 : pushData.lowBatteryThreshold;
            if(!isEqualObjects(otherRules, savedRules))     sendDataToFire(pushData)
            setOtherRulesError({});
            if(dlrFeatureFlag){
                // if dlr features is enable then only we are updating ml prediction status
                if((pushData.enableToBeFoundAutomation == false && savedRules.enableToBeFoundAutomation == true) &&
                    lastMlStatus === DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.ENABLE
                ){
                    changeMLPredictionStatus(DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.DISABLE_IN_PROGRESS);
                }
            }
        }
    }

    async function sendDataToFire(finalData) {
        try{
            if(finalData.enableFoundAutomation) {
                let value = 0; let foundValue = 3;
                let deviceData = { deviceState: value, deviceStateUpdatedBy: 0 }
                let batch = firestore.batch();
                let arrDocId = [];
                let devices = await firestore
                    .collection('tenants')
                    .doc(companyID)
                    .collection('Devices')
                    .where('deviceState', '==', foundValue)
                    .get()
    
                devices.forEach((doc) => {
                    arrDocId.push(doc.id)
                })  
    
                if(arrDocId.length) {
                    for(var a = 0; a < arrDocId.length; ++a) {
                        let docId = arrDocId[a];
                        let monitorDocRef = firestore.collection("tenants")
                                            .doc(companyID)
                                            .collection('Devices')
                                            .doc(docId)
                                            .collection('Monitor')
                                            .doc('DeviceState')
    
                        batch.set(monitorDocRef,deviceData,{merge:true})
    
                        let docRef = firestore.collection("tenants")
                                        .doc(companyID)
                                        .collection('Devices')
                                        .doc(docId)
    
                        batch.set(docRef,deviceData,{merge:true})
                    }
                }
                try{
                    await batch.commit();
                }catch(err){
                    serverResponse.current = {status:false,msg:"Error in updating Devices"}
                    setSnackbarOpen(true);
                    return;
                } 
            }
            
            let oldSettings = globalAppSettings;
            oldSettings['workFlowData'] = finalData;
            setGlobalAppSettings(oldSettings);
    
            setIsLoading(true)
            let data = finalData;
            let response = await firebaseUtil.saveAppSettings(data, t);
            response && setIsLoading(false);
            serverResponse.current = response;
            if (response.status) {
                setValuesChanged(false);
                setSavedRules({...finalData})
            }
            setSnackbarOpen(true);
        }catch(err){
            serverResponse.current = err;
            setSnackbarOpen(true);
            setIsLoading(false);
        }
    }

    const changedCheck = (val, ruleObj) => {
        setValuesChanged(true)
        if (val === 'rule7') {
            let filtered = {}
            Object.keys(toBeFoundRules).forEach(prop => {
                if (prop !== 'rule2') {
                    filtered[prop] = toBeFoundRules[prop]
                }
                setToBeFoundRules(filtered)
            })
        }

        let obj = ruleObj.definition
        obj['executionMode'] = ruleObj.executionMode

        if (toBeFoundRules[val]) {
            let filtered = {}
            Object.keys(toBeFoundRules).forEach(prop => {
                if (prop !== val) {
                    return filtered[prop] = toBeFoundRules[prop]
                }
                return setToBeFoundRules(filtered)
            })
        }
        else {
            setToBeFoundRules(prevState => ({
                ...prevState,
                [val]: obj
            }))
        }
    }

    const valChecked = (rule) => {
        if (toBeFoundRules && toBeFoundRules[rule]) {
            return true
        }
        return false;
    }

    const valDisabled = (rule) => {
        if(isMlUpdateInProgress) return true;

        if ((otherRules.enableToBeFoundAutomation&& isRuleBased)) {
            let keys = Object.keys(localRulesArr[0].mobile.toBeFoundRules)
            for (let j = 0; j < keys.length; j++) {
                if (toBeFoundRules && toBeFoundRules[keys[j]]) {
                    let offOnes = localRulesArr[0].mobile.toBeFoundRules[keys[j]].validation.exclusiveOf
                    for (let index = 0; index < offOnes.length; index++) {
                        if (rule === offOnes[index]) {
                            return true
                        }
                    }
                }
            }
        } else {
            return true
        }
    }

    const onBlurInp = (value, name) => {
        setOtherRules(prevState => ({
            ...prevState,
            [name]: value ? value : 15
        }))
    }

    const onBlurInpLowBattery = (value, name) => {
        setOtherRules(prevState => ({
            ...prevState,
            [name]: (value === 0 || value) ? value : 'Device default'
        }))
    }

    function handleMlStatusChange(e) {
        if(e.target.value === "0"){
            setIsRuleBased(true);
        }
        else if(e.target.value === "1"){
            setIsRuleBased(false);
        }
    }


    async function changeMLPredictionStatus(val) {
        console.log(val);
        if(isPredictionAvailable){
            await firestore
            .collection('tenants')
            .doc(companyID)
            .collection('Configuration')
            .doc('AppSettings')
            .collection("DLRSettings")
            .doc("DLRConfig")
            .update({MLPredictionStatus: val})
        }
        else{
            await firestore
            .collection('tenants')
            .doc(companyID)
            .collection('Configuration')
            .doc('AppSettings')
            .collection("DLRSettings")
            .doc("DLRConfig")
            .set({MLPredictionStatus: val})
        }
        
        serverResponse.current = {
            status: 200,
            msg: t("messages.success.success1")
        };
        setSnackbarOpen(true);
        setIsLoading(false);
        setValuesChanged(false);
    }

    const onClickCancelBtn = () => {
        setIsLoading(true);
        if(lastMlStatus === DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.ENABLE){
            setIsRuleBased(false);
        }
        else if(lastMlStatus === DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.DISABLE){
            setIsRuleBased(true);
        }
        setDbToLocal();
        setValuesChanged(false);
    }

    function viewMachineLearning () {
        history.push('/settings/auto/MachineLearning');
    }
    function viewConfiguration() {
        history.push("/settings/notifications?id=0");
    }

    const getToolTip = option => {
        if(isMlUpdateInProgress){
            if(lastMlStatus === DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.DISABLE){
                return t('workFlow.unenrolmentProgressToolTip') 
            }
            else if(lastMlStatus === DLR_MACHINE_LEARNING.ML_PREDICTION_STATUS.ENABLE){
                return t('workFlow.enrolmentProgressToolTip')
            }
            else{
                return "";
            }
        }
        else{
            if(option === "rulebased"){
                return t('workFlow.ruleBased')
            }
            else if(option === "machineLearning"){
                return t('workFlow.machineLearning')
            }
            else if(option === "rules"){
                return t('workFlow.rules')
            }
            else{
                return "";
            }
        }
    }

    const QuestionTT = withStyles((theme) => ({
        tooltip: {
            backgroundColor: '#000000',
            color: theme.typography.pxToRem(14),
            maxWidth: 300,
            border: '1px solid #000000'
        },
        arrow: {
            color: '#000000'
        }
    }))(Tooltip);

    function getRedioButtomHtml() {
        return(
            <>
                <RadioGroup id='play-sound' aria-label="play-sound-type" name="play-sound-type" data-testid="audioOption"
                    value={ isRuleBased? 0 : 1 }
                    onChange={e =>  handleMlStatusChange(e) }
                    disabled={!otherRules.enableToBeFoundAutomation || isScreenBlock}
                    style={{ marginLeft: "40px" }}
                >
                    <FormControlLabel value={0}
                        control={
                            <Radio color="default" id='rulebased' data-testid="rulebased" style={{ color: "#0073e6" }}
                                disabled={!otherRules.enableToBeFoundAutomation || isScreenBlock}
                            />
                        }
                        label={<PageLabel id="rulebased">
                            {t('workFlow.ruleBased')}
                            <QuestionTT arrow title={<><TTBody>{getToolTip("rulebased")}</TTBody></>}>
                                <SVGContainer>
                                    <HelpOutlineIcon />
                                </SVGContainer>
                            </QuestionTT>
                        </PageLabel>}
                    />
                    {
                        isRuleBased && (
                            <>
                                <PageLabel style={{ marginLeft: "30px" }}>
                                    {t(`workFlow.rulesInstruction`)}
                                </PageLabel>
                                {
                                    Object.keys(localRulesArr.map(val => val.mobile.toBeFoundRules)[0]).map((val, idx) =>
                                        <CheckboxCompSub id={val} style={!dlrFeatureFlag ? { marginLeft: "40px" } : { marginLeft: "20px" }}>
                                            <Checkbox
                                                color="default"
                                                style={{color:"#0073e6"}}
                                                disabled={valDisabled(val) || isScreenBlock}
                                                checked={valChecked(val) == undefined ? false : valChecked(val)}
                                                onChange={(e) => changedCheck(val, localRulesArr.map(val => val.mobile.toBeFoundRules)[0][val])}
                                            />
                                            <PageLabel style={{ margin: 0 }}>{t(`workFlow.toBeFoundRules.${val}`)}</PageLabel>
                                        </CheckboxCompSub>
                                    )
                                }
                            </>
                        )
                    }
                    <FormControlLabel value={1}
                        control={
                            <Radio color="default" id='machineLearningOption' data-testid="machineLearningOption" 
                                style={{ color: "#0073e6" }} disabled={!otherRules.enableToBeFoundAutomation||isScreenBlock}
                            />
                        }
                        label={<PageLabel id='machineLearningOption'>{t('workFlow.machineLearning')}
                            <QuestionTT arrow title={<><TTBody>{getToolTip("machineLearning")}</TTBody></>}>
                                <SVGContainer>
                                    <HelpOutlineIcon />
                                </SVGContainer>
                            </QuestionTT>
                        </PageLabel>}
                    />
                    {(!isRuleBased)&& 
                        <div style={{"marginLeft":"4.1%"}}>
                            <PageLabel>
                                {t('workFlow.machineLearningLabel')} 
                            </PageLabel>
                            <DescriptionBlock>
                                <DescriptionText>
                                    {t('workFlow.machineLearningSubLabel1')}
                                    <br/>
                                    <br/>
                                    {t('workFlow.machineLearningSubLabel2')}
                                <StyledLink id="machineLearningPage" onClick={viewMachineLearning}>
                                    {t('workFlow.viewMachineLearning')}
                                </StyledLink>
                                <StyledLink id="machineLearningPage" onClick={viewConfiguration}>
                                    {t('workFlow.configureNotifcations')}
                                </StyledLink>
                                </DescriptionText>
                            </DescriptionBlock>
                            
                        </div>
                    }
                </RadioGroup>
                {
                    isMlUpdateInProgress == false && retryStatus == DLR_MACHINE_LEARNING.BULK_RETRY_CONFIG_STATUS.RETRY_FAILED ?
                    <ErrorMsg>
                        We were unable to process your request. We will try again tomorrow at 3 AM UTC
                    </ErrorMsg> : null
                }
            </>
        )
    }

    if(dlrFeatureFlag){
        return (
            <div>
                <link rel="preconnect" href="https://fonts.googleapis.com"/>
                <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin/>
                <link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap" rel="stylesheet"/>
                <PageTitleDiv>
                    <PageHeader>{dlrFeatureFlag ? t('workFlow.thresholdsAndRules') : t('workFlow.Automation')}</PageHeader>
                </PageTitleDiv>
                <MainLayout style={{ cursor: isLoading ? "wait" : "default", opacity: isLoading ? '0.4' : '1' }}>
                    
                    {/* loader */}
                    {isLoading2 && <div style={{ textAlign: 'center' }}>
                        <CircularProgress />
                    </div>}
    
                    {/* Device and Threshold section */}
                    <Section>
                        <FormControl fullWidth>
                            <PageLabel className="playsound-label" data-testid="deviceThreshold" style={{ display: "flex" }}>
                                {t('workFlow.deviceThreshold')}
                                <QuestionTT arrow title={<>
                                        <TTBody>
                                            <p>{t('workFlow.lowBatteryThresholdToolTip')}</p>
                                            <p>{t('workFlow.deviceIdleToolTip')}</p>
                                        </TTBody>
                                    </>}
                                >
                                    <SVGContainer>
                                        <HelpOutlineIcon />
                                    </SVGContainer>
                                </QuestionTT>
                            </PageLabel>
                            <div style={{ marginLeft: "30px", marginTop: "18px" }}>
                                <div className="lost-device-vibrate-pattern pay-sound-custom-dropdwn">
                                    <PageLabel className="playsound-label" data-testid="deviceThreshold">{t('workFlow.deviceThresholdValues.lowBatteryThreshold')}</PageLabel>
                                    <StyledTextField
                                        data-testid="customeTone"
                                        value={(otherRules.lowBatteryThreshold === 9999 || otherRules.lowBatteryThreshold === 'Device default') ? t(`workFlow.deviceDefault`) : otherRules.lowBatteryThreshold}
                                        variant="outlined"
                                        onChange={(e) => onChangeOtherRules(e.target.value, 'lowBatteryThreshold')}
                                        disabled={ isScreenBlock }
                                        inputProps={{
                                            maxLength: 3,
                                        }}
                                        onBlur={() => onBlurInpLowBattery(otherRules.lowBatteryThreshold, 'lowBatteryThreshold')}
                                        placeholder={t(`workFlow.value`)}
                                        error={otherRulesError.lowBatteryThreshold}
                                        helperText={otherRulesError.lowBatteryThreshold && t(`workFlow.error.${otherRulesError.lowBatteryThreshold}`)}
                                    />
                                </div>
                                <div className="lost-device-vibrate-pattern pay-sound-custom-dropdwn">
                                    <PageLabel className="playsound-label" data-testid="maxcheckoutTime">{t('workFlow.deviceThresholdValues.maxcheckoutTime')}</PageLabel>
                                    <StyledTextField
                                        disabled={isScreenBlock}
                                        variant="outlined"
                                        error={otherRulesError.lowBatteryThreshold}
                                        inputProps={{
                                            maxLength: 2
                                        }}
                                        onBlur={() => onBlurInpLowBattery(otherRules.lowBatteryThreshold, 'lowBatteryThreshold')}
                                        placeholder={t(`workFlow.value`)}
                                        value={otherRules.maxCheckoutTime}
                                        onChange={(e) => onChangeOtherRules(e.target.value, 'maxCheckoutTime')}
                                        helperText={otherRulesError.lowBatteryThreshold && t(`workFlow.error.${otherRulesError.lowBatteryThreshold}`)}
                                    />
                                </div>
                                <div className="lost-device-vibrate-pattern pay-sound-custom-dropdwn" style={{ marginTop: "12px" }}>
                                    <PSubHeading id='deviceIdle'>
                                        <PageLabel style={{ margin: "0px" }}>{t('workFlow.deviceThresholdValues.deviceIdle')}</PageLabel>
                                        <SwitchCustomColor
                                            disabled={isScreenBlock}
                                            checked={otherRules?.enableIdleDetection == undefined ? false : otherRules.enableIdleDetection}
                                            onChange={(e) => onChangeOtherRules(e.target.checked, 'enableIdleDetection')}
                                        />
                                    </PSubHeading>
                                    <div className="lost-device-vibrate-pattern pay-sound-custom-dropdwn" style={{ marginLeft: "30px" }}>
                                        <PageLabel className="playsound-label" data-testid="deviceThreshold">{t('workFlow.deviceThresholdValues.deviceIdleThresholdTime')}</PageLabel>
                                        <StyledTextField
                                            error={otherRulesError.idleThreshold}
                                            variant="outlined"
                                            inputProps={{
                                                maxLength: 6,
                                            }}
                                            onBlur={() => onBlurInp(otherRules.idleThreshold, 'idleThreshold')}
                                            placeholder={'15'}
                                            value={otherRules.idleThreshold}
                                            onChange={(e) => onChangeOtherRules(e.target.value, 'idleThreshold')}
                                            disabled={!otherRules.enableIdleDetection}
                                            helperText={otherRulesError.idleThreshold && t(`workFlow.error.${otherRulesError.idleThreshold}`)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </FormControl>
                    </Section>
    
    
                    {/* section for update tracking state */}
                    <section style={{ marginTop: "8px" }}>
                        <FormControl fullWidth>
                            <CheckboxComp>
                                <Checkbox
                                    color="default"
                                    style={{color:"#0073e6"}}
                                    disabled={ isScreenBlock }
                                    checked={otherRules?.enableToBeFoundAutomation == undefined ? false : otherRules.enableToBeFoundAutomation}
                                    onChange={(e) => onChangeOtherRules(e.target.checked, 'enableToBeFoundAutomation')}
                                />
                                    <PageLabel>
                                        { t('workFlow.automaticallyMarkDevicesRetrival2') }
                                        <QuestionTT arrow title={<TTBody>{t("workFlow.automaticallyMarkDevicesRetrivalToolTip")}</TTBody>}>
                                            <SVGContainer>
                                                <HelpOutlineIcon />
                                            </SVGContainer>
                                        </QuestionTT>
                                    </PageLabel>
                            </CheckboxComp>
                            {   isScreenBlock ?
                                <>
                                    <div style={{"opacity":"0.1"}}>{getRedioButtomHtml()}</div> 
                                    <Pprocessing style={isRuleBased ? {bottom: "250px", width: "777px"} : {bottom: "160px", width: "777px"}}>
                                        {t('mlTimeoutPage.processing')} 
                                        {
                                            processingTimer.length > 0 && 
                                            <>
                                                &nbsp;({processingTimer} {t('mlTimeoutPage.timeLeft')})
                                            </>
                                        }
                                        <div style={{ marginTop: "20px" }}>
                                            <LinearProgressWithLabel value={progressBarValue} />
                                        </div>
                                    </Pprocessing> 
                                </> 
                                : getRedioButtomHtml()
                            }
                        </FormControl>
                    </section>
    
                    <CheckboxComp>
                        <Checkbox
                            disabled={ isScreenBlock }
                            color="default"
                            style={{color:"#0073e6"}}
                            checked={otherRules?.enableFoundAutomation == undefined ? false : otherRules.enableFoundAutomation}
                            onChange={(e) => onChangeOtherRules(e.target.checked, 'enableFoundAutomation')}
                        />
                        <PageLabel>
                            {t('workFlow.automaticallyClearDeviceState')}
                            <QuestionTT arrow title={<>
                                <TTBody>{t("workFlow.automaticallyClearDeviceStateToolTip")}</TTBody>
                                        </>}>
                                <SVGContainer>
                                    <HelpOutlineIcon />
                                </SVGContainer>
                            </QuestionTT>
                        </PageLabel>
                    </CheckboxComp>
    
                    <CheckboxComp>
                        <Checkbox
                            disabled={ isScreenBlock }
                            color="default"
                            style={{color:"#0073e6"}}
                            checked={otherRules?.enableInServiceOnCheckout == undefined ? false : otherRules.enableInServiceOnCheckout}
                            onChange={(e) => onChangeOtherRules(e.target.checked, 'enableInServiceOnCheckout')}
                        />
                        <PageLabel>{t('workFlow.automateCheckout')}</PageLabel>
    
                        <QuestionTT arrow title={<>
                            <TTBody>
                                {t('workFlow.automaticallySetInServiceOnCheckoutToolTip')}
                            </TTBody>
                        </>}>
                            <SVGContainer>
                                <HelpOutlineIcon />
                            </SVGContainer>
                        </QuestionTT>
    
                    </CheckboxComp>
    
                    <Section>
                        <ButtonContainer>
                            <Button
                                id="resetBtn"
                                data-testid="resetBtn"
                                onClick={onClickResetBtn}
                                disabled={isScreenBlock}
                                style={{
                                    textTransform: "none",
                                    marginLeft: '0px',
                                    border: "1px solid #D70015",
                                    fontWeight:"500", 
                                    background: "white",
                                    color:"#D70015",
                                    marginRight:"auto",
                                    padding: "12px 24px"
                                }}
                            >
                                {t('workFlow.button.resetDefault')}   
                            </Button>
                            <Button
                                id="cancelBtn"
                                data-testid="cancelBtn"
                                disabled={!valuesChanged || isScreenBlock}
                                onClick={() => onClickCancelBtn()}
                                style={{
                                    textTransform: "none",
                                    borderRadius: '5px',
                                    marginLeft: '0px', 
                                    background: (!valuesChanged) ? '#E8EBF1' : '#f5f1f1', 
                                    color: (!valuesChanged) ? '#929AA9' : 'black',
                                    fontWeight:"500",
                                    padding: "12px 24px"
                                }}
                            >
                                {t('workFlow.button.cancel')}
                            </Button>
                            <Button
                                id="saveBtn"
                                data-testid="saveBtn"
                                disabled={!valuesChanged || isScreenBlock}
                                onClick={onClickRulesSaveBtn}
                                style={{ 
                                    textTransform: "none",
                                    borderRadius: '4px',
                                    fontWeight:"500",
                                    backgroundColor: (!valuesChanged) ? '#E8EBF1' : '#0073E6', 
                                    width: "150px", 
                                    height: "48px",
                                    marginLeft:"10px", 
                                    color: (!valuesChanged) ? '#929AA9' : "white",
                                    padding: "12px 24px"
                                }}
                            >
                                {t('mlTimeoutPage.saveChanges')}
                            </Button>
                        </ButtonContainer>
                    </Section>
    
                    <Snackbar
                        open={snackbarOpen}
                        autoHideDuration={5000}
                        onClose={() => setSnackbarOpen(false)}
                    >
                        <SnackbarContent error={serverResponse.current.status ? false : true}>
                            {serverResponse.current.msg}
                        </SnackbarContent>
                    </Snackbar>

                    <BottomNavLinks />
                </MainLayout>
            </div>
        )
    }
    else{
        return (
            <div>
                <PageWrapper style={{ cursor: isLoading ? "wait" : "default", opacity: isLoading ? '0.4' : '1' }}>
                    <PageTitle>{
                        dlrFeatureFlag ? t('workFlow.thresholdsAndRules') : t('workFlow.Automation')
                    }</PageTitle>
                    {isLoading2 && <div style={{ textAlign: 'center' }}>
                        <CircularProgress />
                    </div>}             
    
                    <div style={{ display: isLoading2 ? "none" : "block" }}>
                        <RuleTitle>{t('workFlow.deviceThreshold')}
                            <QuestionTT arrow title={<>
                                <TTBody>
                                    <p>
                                        {t('workFlow.lowBatteryThresholdToolTip')}
                                    </p>
                                    <p>
                                        {t('workFlow.deviceIdleToolTip')}
                                    </p>
                                </TTBody>
                            </>}>
                                <SVGContainer value={{color: "#929AA9"}}>
                                    <HelpOutlineIcon/>
                                </SVGContainer>
                            </QuestionTT>
                        </RuleTitle>
    
                        <PSub>
                            <NoMarginP>{t('workFlow.deviceThresholdValues.lowBatteryThreshold')}</NoMarginP>
                            <StyledTextFieldOld
                                disabled={isMlUpdateInProgress}
                                error={otherRulesError.lowBatteryThreshold}
                                InputProps={{
                                    endAdornment: <InputAdornment position="start">
                                        {t('workFlow.deviceThresholdValues.percentage')}
                                    </InputAdornment>,
                                }}
                                inputProps={{
                                    maxLength: 3,
                                }}
                                onBlur={() => onBlurInpLowBattery(otherRules.lowBatteryThreshold, 'lowBatteryThreshold')}
    
                                placeholder={t(`workFlow.value`)}
                                value={(otherRules.lowBatteryThreshold === 9999 || otherRules.lowBatteryThreshold === 'Device default') ? t(`workFlow.deviceDefault`) : otherRules.lowBatteryThreshold}
                                onChange={(e) => onChangeOtherRules(e.target.value, 'lowBatteryThreshold')}
                                helperText={otherRulesError.lowBatteryThreshold && t(`workFlow.error.${otherRulesError.lowBatteryThreshold}`)}
                            />
                        </PSub>
                        <PSub>
                            <NoMarginP>{t('workFlow.deviceThresholdValues.maxcheckoutTime')}</NoMarginP>
                            <StyledTextFieldOld
                                disabled={isMlUpdateInProgress}
                                error={otherRulesError.lowBatteryThreshold}
                                InputProps={{
                                    endAdornment: <InputAdornment position="start">{t('workFlow.deviceThresholdValues.hours')}</InputAdornment>,
                                }}
                                inputProps={{
                                    maxLength: 2,
                                }}
                                onBlur={() => onBlurInpLowBattery(otherRules.lowBatteryThreshold, 'lowBatteryThreshold')}
                                placeholder={t(`workFlow.value`)}
                                value={otherRules.maxCheckoutTime}
                                onChange={(e) => onChangeOtherRules(e.target.value, 'maxCheckoutTime')}
                                helperText={otherRulesError.lowBatteryThreshold && t(`workFlow.error.${otherRulesError.lowBatteryThreshold}`)}
                            />
                        </PSub>
                        <PSub id='deviceIdle'>
                            <NoMarginP>{t('workFlow.deviceThresholdValues.deviceIdle')}</NoMarginP>
                            <ZSwitch
                                disabled={isMlUpdateInProgress}
                                style={{backgroundColor: '#1D1E23', bottom: '29.17%',top: '29.17%'}}
                                checked={otherRules?.enableIdleDetection == undefined ? false : otherRules.enableIdleDetection}
                                onChange={(e) => onChangeOtherRules(e, 'enableIdleDetection')}
                            />
                        </PSub>
                        <PSub id='deviceIdleThresholdTime'>
                            <NoMarginP style={{ marginLeft: '20px' }}>{t('workFlow.deviceThresholdValues.deviceIdleThresholdTime')}</NoMarginP>
                            <StyledTextFieldOld
                                error={otherRulesError.idleThreshold}
                                InputProps={{
                                    endAdornment: <InputAdornment position="start">{t('workFlow.deviceThresholdValues.minutes')}</InputAdornment>,
                                }}
                                inputProps={{
                                    maxLength: 6,
                                }}
                                onBlur={() => onBlurInp(otherRules.idleThreshold, 'idleThreshold')}
                                placeholder={'15'}
                                value={otherRules.idleThreshold}
                                onChange={(e) => onChangeOtherRules(e.target.value, 'idleThreshold')}
                                disabled={!otherRules.enableIdleDetection}
                                helperText={otherRulesError.idleThreshold && t(`workFlow.error.${otherRulesError.idleThreshold}`)}
                            />
                        </PSub>
                        <CheckboxComp>
                            <Checkbox
                                checked={otherRules?.enableToBeFoundAutomation == undefined ? false : otherRules.enableToBeFoundAutomation}
                                onChange={(e) => onChangeOtherRules(e.target.checked, 'enableToBeFoundAutomation')}
                            />
                            <h4>{t('workFlow.automaticallyMarkDevicesRetrival1')}</h4>
                            <QuestionTT arrow title={<>
                                <TTBody>
                                    {t('workFlow.automaticallyMarkDevicesRetrivalToolTip')}
                                </TTBody>
                            </>}>
                                <SVGContainer>
                                    <HelpOutlineIcon />
                                </SVGContainer>
                            </QuestionTT>
                        </CheckboxComp>
                        {
                            Object.keys(localRulesArr.map(val => val.mobile.toBeFoundRules)[0]).map((val, idx) =>
                                <CheckboxCompSub id={val} style={!dlrFeatureFlag ? { marginLeft: "40px" } : { marginLeft: "70px" }}>
                                    <Checkbox
                                            disabled={valDisabled(val)}
                                            checked={valChecked(val) == undefined ? false : valChecked(val)}
                                            onChange={(e) => changedCheck(val, localRulesArr.map(val => val.mobile.toBeFoundRules)[0][val])}
                                    />
                                    <NoMarginP>{t(`workFlow.toBeFoundRules.${val}`)}</NoMarginP>
                                </CheckboxCompSub>
                            )
                        }
    
                        <CheckboxComp>
                            <Checkbox
                                checked={otherRules?.enableFoundAutomation == undefined ? false : otherRules.enableFoundAutomation}
                                onChange={(e) => onChangeOtherRules(e.target.checked, 'enableFoundAutomation')}
                            />
                            <h4>{t('workFlow.automaticallyClearDeviceState')}</h4>
                            <QuestionTT arrow title={<>
                                <TTBody>
                                    {t('workFlow.automaticallyClearDeviceStateToolTip')}
                                </TTBody>
                            </>}>
                                <SVGContainer>
                                    <HelpOutlineIcon />
                                </SVGContainer>
                            </QuestionTT>
                        </CheckboxComp>
    
                        <CheckboxComp>
                            <Checkbox
                                 checked={otherRules?.enableInServiceOnCheckout == undefined ? false : otherRules.enableInServiceOnCheckout}
                                 onChange={(e) => onChangeOtherRules(e.target.checked, 'enableInServiceOnCheckout')}
                            />
                            <h4>{t('workFlow.automateCheckout')}</h4>
    
                            <QuestionTT arrow title={<>
                                <TTBody>
                                    {t('workFlow.automaticallySetInServiceOnCheckoutToolTip')}
                                </TTBody>
                            </>}>
                                <SVGContainer>
                                    <HelpOutlineIcon />
                                </SVGContainer>
                            </QuestionTT>
    
                        </CheckboxComp>
    
                        {valuesChanged &&
                            <ButtonContainerOld>
                                <ZButton
                                    id="cancelBtn"
                                    onClick={() => onClickCancelBtn()}
                                    type="primary"
                                    style={{ marginLeft: '0px', background: 'white', color: 'black', border: '1px solid gray',borderRadius: '5px',fontWeight:"600" }}
                                >
                                    {t('workFlow.button.cancel')}
                                </ZButton>
                                <ZButton
                                    id="saveBtn"
                                    onClick={onClickRulesSaveBtn}
                                    type="primary"
                                    style={{ marginLeft: '0px',borderRadius: '5px',fontWeight:"500",backgroundColor: '#0073E6' }}
                                >
                                    {t('workFlow.button.save')}
                                </ZButton>
                            </ButtonContainerOld>
                        }
                            
                        <Snackbar
                            open={snackbarOpen}
                            autoHideDuration={5000}
                            onClose={() => setSnackbarOpen(false)}
                        >
                            <SnackbarContent error={serverResponse.current.status ? false : true}>
                                {serverResponse.current.msg}
                            </SnackbarContent>
                        </Snackbar>
                    </div>
                    <BottomNavLinks />
                </PageWrapper>
                {/* <p>v0.05</p> */}
            </div>
        )
    }
}

export default WorkFlow;